import { Injectable } from '@angular/core';
import { FileAttachment } from '../models/fileAttachment.model';
import { GridService } from '../shared/grid/grid.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileAttachmentService extends GridService<FileAttachment> {

  constructor(http: HttpClient) {
    super('FileAttachment', http);
  }
}
